import React, { useState } from 'react';
import { useI18n } from '../i18n/index.jsx';
import AuthLayout from './auth/AuthLayout.jsx';

// Small shared form/feedback pieces.

export function Field({ label, hint, optional, children, htmlFor }) {
  const { t } = useI18n();
  return (
    <div className="field">
      <label htmlFor={htmlFor}>
        {label}
        {optional && <span className="field-optional"> ({t('common.optional')})</span>}
      </label>
      {children}
      {hint && <p className="field-hint">{hint}</p>}
    </div>
  );
}

export function Alert({ kind = 'error', children }) {
  if (!children) return null;
  return <div className={`alert alert-${kind}`} role={kind === 'error' ? 'alert' : 'status'}>{children}</div>;
}

export function EyeIcon({ off }) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z" />
      <circle cx="12" cy="12" r="3" />
      {off && <path d="M3 3l18 18" />}
    </svg>
  );
}

export function PasswordInput(props) {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);
  return (
    <div className="password-input">
      <input {...props} type={visible ? 'text' : 'password'} />
      <button type="button" className="password-eye" onClick={() => setVisible((v) => !v)} aria-pressed={visible}
        aria-label={visible ? t('common.hidePassword') : t('common.showPassword')}>
        <EyeIcon off={visible} />
      </button>
    </div>
  );
}

// Forgot / reset password and email verification use the same card as
// sign-in.
export function AuthCard({ title, lead, children, footer }) {
  return <AuthLayout title={title} lead={lead} below={footer}>{children}</AuthLayout>;
}
